module.exports = __webpack_public_path__ + "img/AOV-header-image.dbd53728.png";